import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPaywallCustomizationPhase2 } from "@/react/hooks/useIsPaywallCustomizationPhase2";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Testimonials } from "./Testimonials";

interface PaywallCustomizationProps {
  className?: string;
  shouldHide?: boolean;
}

export const PaywallCustomization = ({
  shouldHide,
  className,
}: PaywallCustomizationProps) => {
  const { paywall } = usePaywallCheckoutContext();
  const isEnabled = useIsPaywallCustomizationPhase2();

  const paywallCustomization = paywall.paywall_customization;

  const { testimonial_properties: testimonialProperty } =
    paywallCustomization || {};

  if (shouldHide || !isEnabled) {
    return null;
  }

  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-y-9 divide-y *:pt-9",
        className,
      )}
    >
      <Testimonials testimonialProperty={testimonialProperty} />
    </div>
  );
};
